/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon16Regular = forwardRef('NetDownloadIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 .675a.75.75 0 0 1 .75.75V9.13l3.252-2.89a.75.75 0 0 1 .996 1.12l-3.503 3.115a2.25 2.25 0 0 1-2.99 0L3.002 7.36a.75.75 0 1 1 .996-1.122L7.25 9.13V1.426A.75.75 0 0 1 8 .675Z" }),
        React.createElement("path", { d: "M1.75 13a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75Z" })));
});
